export default __webpack_public_path__ + "static/media/ic-paso-dos.f3068ec5.svg";